export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

/**
 * Función que verifica si acaso hay intersección entre 2 intervalos numéricos
 * @param {number} start1
 * @param {number} end1
 * @param {number} start2
 * @param {number} end2
 * @returns true si hay intersección, false si no
 */
export const intercept = (start1, end1, start2, end2) => {
  return Math.max(0, Math.min(end2, end1) - Math.max(start1, start2) + 1) > 0;
};

export const getUrlBase64 = (base64, contentType) => {
  const index = base64.indexOf(',');
  const archivoBase64 = base64.slice(index + 1, base64.length);

  const blob = b64toBlob(archivoBase64, contentType);
  return URL.createObjectURL(blob);
};

export const iosDevice = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export const mobileDevice =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
  /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform);

export const concatenateObjectValues = (obj) => {
  const arr = Object.keys(obj).reduce(function (res, v) {
    const current = obj[v].map((item) => {
      let name;
      if (item === 0) {
        name = 'Presencial';
      } else if (item === 1) {
        name = 'Videoconsulta';
      } else {
        name = item;
      }
      return { type: v, value: item, name };
    });
    return res.concat(current);
  }, []);
  return arr;
};

export const sortByKey = (arr, key) => {
  return arr.sort(function (a, b) {
    return a[key].localeCompare(b[key]);
  });
};
